module.exports = __webpack_public_path__ + "static/media/cart.c0298bb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cart.svg
// module id = 790
// module chunks = 0